import React, { useRef, useState, useEffect } from "react";
import { styled } from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import { DropdownFilled } from "../../assets/icons";

const AquaDurationDropdown = ({
  data,
  placeholder,
  width,
  cartindex,
  selected,
  onSelect,
}) => {
  const [visible, setVisible] = useState(false);
  const handleOpen = () => {
    setVisible(!visible);
  };
  const getLabel = (value) => {
    return data?.filter((item) => item?.value === value)[0]?.label;
  };
  const getPrice = (value) => {
    return data?.filter((item) => item?.value === value)[0]?.price || 0;
  };

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setVisible(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };
  const modalWrapperRef = useRef(null);

  useOutsideAlerter(modalWrapperRef);

  return (
    <DropdownContainer width={width} onClick={handleOpen} ref={modalWrapperRef}>
      <DropdownLabel>{getPrice(selected)} QAR</DropdownLabel>
      <DropdownSubContainer>
        <DropdownValue>{getLabel(selected) || "Select Duration"}</DropdownValue>
        <DropdownImage src={DropdownFilled} />
      </DropdownSubContainer>
      {visible && (
        <DropdownList>
          {data.map((item, index) => (
            <ListValue
              key={index}
              onClick={() =>
                onSelect(item?.value, getPrice(item?.value), cartindex)
              }
              selected={item?.value === selected}
            >
              {item?.label}
            </ListValue>
          ))}
        </DropdownList>
      )}
    </DropdownContainer>
  );
};

const DropdownContainer = styled.div`
  width: ${(props) => props.width};
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  position: relative;
  @media only screen and (max-width: 1024px) {
    width: 100%;
  }
`;

const DropdownLabel = styled.span`
  color: ${Colors.doveGrey};
  font-size: 0.6rem;
  font-weight: 500;
  text-align: right;
`;
const DropdownSubContainer = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  background: ${Colors.darkShadeGreywithOpacity};
  align-items: center;
  justify-content: space-between;
  padding: 0.7rem 1rem;
`;
const DropdownValue = styled.span`
  color: ${Colors.black};
  font-size: 1rem;
  font-weight: 500;
`;
const DropdownImage = styled.img`
  width: 1.125rem;
  height: 0.5rem;
`;
const DropdownList = styled.div`
  background-color: ${Colors.veryDrakGrey};
  display: flex;
  flex-direction: column;
  padding: 0.2rem 0;
  text-align: left;
  justify-content: space-around;
  z-index: 1;
  position: absolute;
  top: 4rem;
  width: 50%;
`;
const ListValue = styled.span`
  color: ${props=>props.selected ? Colors.aqua : Colors.white};
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.4rem 0.5rem;
`;

export default AquaDurationDropdown;
